import { render, staticRenderFns } from "./Toggles.vue?vue&type=template&id=e7f08f9a&"
import script from "./Toggles.vue?vue&type=script&lang=ts&"
export * from "./Toggles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports